// src/PasswordReset.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import axios from 'axios';
import { createTheme, ThemeProvider } from '@mui/material/styles';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://macct.tw/">
        Master Accounting
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const defaultTheme = createTheme();

export default function SignUp() {
    const navigate = useNavigate();

    const queryParameters = new URLSearchParams(window.location.search)
    const auth = queryParameters.get("auth");

    const [formData, setFormData] = useState(false); 
    const [emailValue, setEmailValue] = useState(""); 
    const [fullNameValue, setFullNameValue] = useState(""); 

    useEffect(() => {
        if(!auth){
            return (
              <div className="App">
                  <h2>聯結有誤</h2>
                  <p>請重新確認連結，或是聯繫公司</p>
              </div>
            );
        }

        axios.get(`https://macct.tw/api/profile?auth=${auth}`)
        .then((response) => {
            if (response.data.success) {
                console.log(response.data);
                setFormData(response.data.data);
                setEmailValue(response.data.data.username);
                setFullNameValue(response.data.data.fullName);
                console.log(emailValue);
            } else {
                console.log(response.data);
                alert("發生錯誤:"+response.data.message);
                navigate('/login');
            }
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        if(data.get('password') != data.get('passwordCheck')){
            alert("新密碼不一致");
            return false;
        }

        let form = {
            "fullName":data.get('fullName'),
            "email":data.get('email'),
            "password":data.get('password')
        };
    
        try {
            const response = await fetch('https://macct.tw/api/resetpasswordconfirm', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'credentials': 'include'
            },
            body: JSON.stringify(form),
            });
            console.log(form);
    
            const responseData = await response.json();
    
            if (responseData.success) {
                // 登入成功的處理
                alert('密碼更新成功！');
                navigate('/login'); // 導向Home.js
            } else {
                // 登入失敗的處理
                alert('密碼更新失敗：'+responseData.message);
            }
        } catch (error) {
        console.error('Error:', error);
        }
    };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            重設密碼
          </Typography>
          <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  autoComplete="full-name"
                  name="fullName"
                  fullWidth
                  id="fullName"
                  label="全名"
                  value={fullNameValue}
                  InputProps={{readOnly: true}}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="email"
                  label="Email地址"
                  name="email"
                  value={emailValue}
                  InputProps={{readOnly: true}}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="password"
                  label="新密碼"
                  type="password"
                  id="password"
                  autoComplete="new-password"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  name="passwordCheck"
                  label="再輸入一次密碼"
                  type="password"
                  id="passwordCheck"
                  autoComplete="new-password-check"
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
             重設密碼
            </Button>
          </Box>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}